export const updateSitesListPredefinedFilters = (data: any) => ({
  type: "UPDATE_SITES_LIST_PREDEFINED_FILTERS",
  payload: data,
});
